import styled from 'styled-components'

import { IndexLayoutOldSubtitle } from '@sketch/modules-common'
import { Text } from '@sketch/components'

export const VerificationCodeContainer = styled.div`
  margin-top: 24px;
  margin-bottom: 40px;
`

export const LinkDescription = styled(Text).attrs({
  textStyle: 'copy.tertiary.standard.C',
})`
  margin-bottom: 8px;
`

export const Subtitle = styled(IndexLayoutOldSubtitle)`
  max-width: 400px;
  margin: 8px auto 0;
`
